import { createSlice } from "@reduxjs/toolkit";
import { EditEventState } from "../../types";

const initialState: EditEventState = {
  currentId: "",
  selectedEvents: [],
  changedFormSuccessfull: false
};

export const editSlice = createSlice({
  name: "editEvent",
  initialState,
  reducers: {
    setCurrentId(state: EditEventState, action: any) {
      state.currentId = action.payload;
    },
    editSelectedEvents(state: EditEventState, action: any) {
      state.selectedEvents = action.payload;
    },
    setChangedFormSuccessfull(state: EditEventState, action: any) {
      state.changedFormSuccessfull = action.payload;
    },
    reset() {
      return initialState;
    }
  }
});

const { reducer } = editSlice;

export default reducer;
